// LiveKit Configuration

export const livekitConfig = {
  url: import.meta.env.VITE_LIVEKIT_URL || '',
  apiKey: import.meta.env.VITE_LIVEKIT_API_KEY || '',
  apiSecret: import.meta.env.VITE_LIVEKIT_API_SECRET || '',
} as const

/**
 * Check if LiveKit is properly configured
 */
export function isLiveKitConfigured(): boolean {
  return !!(
    livekitConfig.url &&
    livekitConfig.apiKey &&
    livekitConfig.apiSecret
  )
}

/**
 * Get LiveKit server URL
 */
export function getLiveKitUrl(): string {
  if (!livekitConfig.url) {
    throw new Error('LiveKit URL is required. Set VITE_LIVEKIT_URL in your .env file.')
  }
  return livekitConfig.url
}
